module.exports = __webpack_public_path__ + "img/dotd.b182d06b.jpg";